const numeric = /^[0-9]+$/;
const compareIdentifiers = (a, b) => {
  const isANum = numeric.test(a);
  const isBNum = numeric.test(b);

  if (isANum && isBNum) {
    a = +a;
    b = +b;
  }

  return a === b
    ? 0
    : isANum && !isBNum
    ? -1
    : isBNum && !isANum
    ? 1
    : a < b
    ? -1
    : 1;
};

export const compare = (version1, version2) => {
  const [major1, minor1, patch1] = version1.split(".");
  const [major2, minor2, patch2] = version2.split(".");

  return (
    compareIdentifiers(major1, major2) ||
    compareIdentifiers(minor1, minor2) ||
    compareIdentifiers(patch1, patch2)
  );
};

export const isBiggerVersion = (version1, version2) =>
  compare(version1, version2) > 0;
